'use client';

import { usePathname } from 'next/navigation';
import { useFeatureFlag } from '@/app/hooks/useFeatureFlag';
import { guideChatScopeForPath } from '@/app/lib/guideChat/triggers';
import GuideChatWidget from './GuideChatWidget';

// Off until switched on in GrowthBook: the widget needs the guide-chat backend and its indexed corpus to answer.
export const GUIDE_CHAT_FEATURE_FLAG = 'guide_chat';

// The assistant lives on the guide cocoons of the products it covers, plus the loan landing and comparator pages.
export default function GuideChatMount() {
  const pathname = usePathname() ?? '';
  const enabled = useFeatureFlag(GUIDE_CHAT_FEATURE_FLAG);
  const scope = guideChatScopeForPath(pathname);
  if (!enabled || !scope) return null;
  return <GuideChatWidget key={pathname} kind={scope.kind} product={scope.product} />;
}
